import { useContext, useEffect } from 'react'
import { NavContext } from '../../context/global_context'
import ErrorCard from '../../components/common/ErrorCard'
import { useIntl } from 'react-intl'
import { CheckCircleOutlined } from '@ant-design/icons'

const LogoutSuccess = () => {
  const intl = useIntl()
  const [state, dispatch] = useContext(NavContext)
  useEffect(() => {
    dispatch({ type: 'header', data: { show_back_btn: false } })
  }, [])

  return (
    <div className="page logout-success">
      <ErrorCard
        icon={CheckCircleOutlined}
        iconStyle={{ color: 'var(--color-success-icon, #389E0D)'}}
        title={intl.formatMessage({ id: 'auth.loggedOut' })}
        sub_title={intl.formatMessage({ id: 'auth.logoutMessage' })}
      />
    </div>
  )
}

export default LogoutSuccess
